"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLineStackFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.ChartLineStackFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M15.5 57L31.5 42.5L53 51.5L68.5 38", stroke: colors[1], strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M12 40L28 25.5L49.5 34.5L65 21", stroke: colors[0], strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }));
    },
    name: 'chart_line_stack_filled',
    defaultColors: ['#7B67EE', '#FFBA2E'],
    colorful: true,
    allPathData: ['M15.5 57L31.5 42.5L53 51.5L68.5 38', 'M12 40L28 25.5L49.5 34.5L65 21'],
    width: '80',
    height: '80',
    viewBox: '0 0 80 80',
});
